import { DevelopedBy, VersionsDisplayer } from '@repo/ui';
import { CpfInput } from 'adasi_components';
import { FormikValues } from 'formik';
import medicalBg from 'presentation/app/assets/images/medical-bg.png';
import { useProductVersions } from 'presentation/app/hooks/use-product-versions';
import React, { SetStateAction } from 'react';
import { Link } from 'react-router-dom';
import {
  Col,
  Row,
  Form,
  Label,
  Input,
  Button,
  Spinner,
  FormFeedback,
} from 'reactstrap';

import { AuthError } from '../../components/auth-error';
import { getEnv } from 'shared/get-env';

interface IPropsAuthentication {
  nome: string;
  error: boolean;
  errorMessage: string;
  loader: boolean;
  passwordShow: boolean;
  validation: FormikValues;
  setPasswordShow: React.Dispatch<SetStateAction<boolean>>;
}

export const LoginView = ({
  nome,
  error,
  errorMessage,
  loader,
  validation,
  passwordShow,
  setPasswordShow,
}: IPropsAuthentication) => {
  const { frontVersion, apiVersion } = useProductVersions();

  return (
    <React.Fragment>
      <div className="nk-content">
        <div className="nk-split nk-split-page nk-split-lg">
          <div className="nk-split-content nk-block-area nk-block-area-column nk-auth-container bg-white">
            <div className="nk-block nk-block-middle nk-auth-body">
              <div className="text-center">
                <img
                  src={getEnv('REACT_APP_URL_LOGO')}
                  alt="logo-rade"
                  height={100}
                />
              </div>
              <div className="text-center mt-3">
                <span className="text-primary fw-bold fs-14">{nome}</span>
                <p className="text-muted">Faça login para continuar</p>
              </div>

              {/* the error must be returned from the API (returning temporarily fixed) */}
              {error && <AuthError message={errorMessage} />}

              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
                action="#"
              >
                <div className="mb-3">
                  <Label htmlFor="cpf" className="form-label">
                    CPF
                  </Label>
                  <CpfInput
                    tabIndex={1}
                    name="cpf"
                    handleChange={validation.handleChange}
                    inputId="cpf"
                    placeholder="CPF"
                    value={validation.values.cpf}
                    className="form-control"
                    invalid={
                      !!(validation.touched.cpf && validation.errors.cpf)
                    }
                  />
                  {validation.touched.cpf && validation.errors.cpf ? (
                    <FormFeedback type="invalid">
                      {validation.errors.cpf}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <div className="float-end">
                    <Link to="/redefinir-senha" className="text-muted">
                      Esqueceu sua senha?
                    </Link>
                  </div>
                  <Label className="form-label" htmlFor="password-input">
                    Senha
                  </Label>
                  <div className="position-relative auth-pass-inputgroup mb-3">
                    <Input
                      name="password"
                      tabIndex={2}
                      value={validation.values.password || ''}
                      type={passwordShow ? 'text' : 'password'}
                      className="form-control pe-5"
                      placeholder="Senha"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      invalid={
                        !!(
                          validation.touched.password &&
                          validation.errors.password
                        )
                      }
                    />
                    {validation.touched.password &&
                    validation.errors.password ? (
                      <FormFeedback type="invalid">
                        {validation.errors.password}
                      </FormFeedback>
                    ) : null}
                    <button
                      className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted me-3"
                      type="button"
                      id="password-addon"
                      onClick={() => setPasswordShow(!passwordShow)}
                    >
                      <i className="ri-eye-fill align-middle"></i>
                    </button>
                  </div>
                </div>

                <div className="form-check">
                  <Input
                    className="form-check-input"
                    type="checkbox"
                    id="keepMeSignedIn"
                    name="keepMeSignedIn"
                    value={validation.values.keepMeSignedIn}
                    defaultChecked={validation.values.keepMeSignedIn}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                  />
                  <Label className="form-check-label" htmlFor="keepMeSignedIn">
                    Mantenha-me conectado
                  </Label>
                </div>

                <div className="mt-4">
                  <Button
                    color="primary"
                    disabled={loader && true}
                    className="btn btn-primary w-100"
                    type="submit"
                  >
                    {loader && (
                      <Spinner size="sm" className="me-2">
                        {['Carregando...']}
                      </Spinner>
                    )}
                    Entrar
                  </Button>
                </div>
              </Form>
            </div>

            <div className="nk-block nk-auth-footer">
              <div className="container wide-lg">
                <Row className="g-3">
                  <Col lg="12">
                    <div className="nk-block-content text-center">
                      <DevelopedBy />
                    </div>
                    <div className="mt-2">
                      <VersionsDisplayer
                        frontAppName="Gestor"
                        frontVersion={frontVersion}
                        apiVersion={apiVersion}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>

          <div className="nk-split-content nk-split-stretch bg-lighter d-flex toggle-break-lg toggle-slide toggle-slide-right">
            <div className="slider-wrap w-100 w-max-550px p-3 p-sm-5 m-auto">
              <div className="slider-init">
                <div className="slider-item">
                  <div className="nk-feature nk-feature-center">
                    <div className="nk-feature-img">
                      <img height={400} src={medicalBg} alt="img" />
                    </div>

                    <div className="nk-feature-content py-4 p-sm-5">
                      <h5 className="text-dark">Gestão de Estágio 4.0</h5>
                      <p>
                        Bem-vindo à nossa plataforma! Somos uma plataforma 100%
                        digital que tem como objetivo aproximar o estudante em
                        formação e sua prática profissional de maneira a
                        analisar, monitorar e incrementar a qualidade do
                        estágio, racionalizar custos e priorizar a humanização.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
